
class EventProgramDetailViewController extends MUIViewController
{
    private ruleTypeComboBox:MUIComboBox = null;
    private segmentedControl:MUISegmentedControl = null;
    private saveButton:MUIButton = null;
    private addButton:MUIButton = null;
    private pageController:MUIPageController = null;

    private infoViewController:EventProgramDetailInfoViewController = null;
    private setupViewController:EventProgramDetailSetupViewController = null;
    private zoneSetupViewController:EventProgramDetailZoneSetupViewController = null;
    private datesViewController:EventProgramDetailDatedViewController = null;

    viewDidLoad(){
        super.viewDidLoad();

        this.ruleTypeComboBox = MUIOutlet(this, "rule-type-cb", "MUIComboBox");
        this.ruleTypeComboBox.setOnChangeAction(this, function(control, index){
            this.zoneSetupViewController.ruleType = parseInt(index);
        });

        this.segmentedControl = MUIOutlet(this, "segmented-control", "MUISegmentedControl");
        this.segmentedControl.setAction(this, function(control, index){
            this.pageController.showPageAtIndex(index);
            this.addButton.setHidden(index == 0);
        });

        this.saveButton = MUIOutlet(this, "save-btn", "MUIButton");
        this.saveButton.setAction(this, function(){
            DBHelper.saveMainContext();
        });

        this.addButton = MUIOutlet(this, "add-btn", "MUIButton");
        this.addButton.setHidden(true);
        this.addButton.setAction(this, this.addAction);        

        this.pageController = MUIOutlet(this, "page-controller", "MUIPageController");
                
        this.infoViewController = new EventProgramDetailInfoViewController("event-program-detail-info-view");
        this.infoViewController.initWithResource('layout/event_program/EventProgramDetailInfoView.html');
        this.pageController.addPageViewController(this.infoViewController);

        this.setupViewController = new EventProgramDetailSetupViewController("event-program-setup-view");
        this.setupViewController.initWithResource("layout/event_program/EventProgramSetupView.html");
        this.pageController.addPageViewController(this.setupViewController);

        this.zoneSetupViewController = new EventProgramDetailZoneSetupViewController("event_programs-booking-zone-setup");
        this.zoneSetupViewController.initWithResource("layout/event_programs/EventProgramsBookingZoneSetupView.html");
        this.pageController.addPageViewController(this.zoneSetupViewController);

        this.datesViewController = new EventProgramDetailDatedViewController("event-program-detail-dates-view");
        this.datesViewController.initWithResource('layout/event_program/EventProgramDetailDatesView.html');   
        this.pageController.addPageViewController(this.datesViewController);
    }

    viewWillAppear(animated?){
        super.viewWillAppear(animated);
        this.updateUI();
    }

    private _eventProgram:EventProgram = null;
    set eventProgram(eventProgram:EventProgram){
        this._eventProgram = eventProgram;
        this.updateUI();        
    }

    private updateUI(){
        if (this.viewIsLoaded == false || this._eventProgram == null) return;
        if (this.infoViewController != null) this.infoViewController.eventProgram = this._eventProgram;
        if (this.setupViewController != null) this.setupViewController.eventProgram = this._eventProgram;
        if (this.zoneSetupViewController != null) this.zoneSetupViewController.eventProgram = this._eventProgram;
        if (this.datesViewController != null) this.datesViewController.eventProgram = this._eventProgram;        
    }

    private addAction(){
        switch(this.segmentedControl.selectedSegmentedIndex){
            case 2: 
                this.addZoneRule();
                break;
            case 3:
                this.addEventProgramDates();
                break;
        }
    }

    private addZoneRule(){
        this.zoneSetupViewController.addRule();
    }

    private addEventProgramDates(){
        let vc = new SelectDateIntervalViewController("select-date-interval-view");
        vc.initWithResource("layout/base/SelectDateIntervalView.html");
        vc.delegate = this;

        this.presentViewController(vc, true);
    }
    
    datesDidSelected(controller:SelectDateIntervalViewController, dates){
        
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;

        for (let index = 0; index < dates.length; index++){
            let date = dates[index];
            let endDate = new Date(date.getTime());
            endDate.setDate(endDate.getDate() + 1);

            let pe = MIOEntityDescription.insertNewObjectForEntityForName("VenueEvent", ad.managedObjectContext) as VenueEvent;
            pe.identifier = MIOUUID.UUID().UUIDString;
            pe.name = this._eventProgram.name;
            pe.beginDateTime = date;
            pe.endDateTime = endDate;
            pe.eventProgram = this._eventProgram;
            pe.externalReference = pe.identifier.toLocaleLowerCase();
        }
        
        ad.managedObjectContext.save();
    }

}